import { Layers, PackageSearch, Truck } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { SERVICES_DETAIL } from '../lib/pageContent';
import { SERVICES_PAGE } from '../constants/testIds';

const ICONS = [Layers, PackageSearch, Truck];

const META_DESCRIPTION =
  'High-density tripling & packing, rigorous sorting & grading, and full container freight & export documentation — the three services behind every BulkUsedTires.com bulk order.';

export default function ServicesPage() {
  useDocumentMeta('Our Services — Sorting, Packing & Freight | BulkUsedTires.com', META_DESCRIPTION);

  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <PageHero
        eyebrow="Services"
        title="We Handle Sorting, Packing & Freight"
        description="Full-service logistics so you receive exactly what was quoted — graded, densely packed and fully documented for customs."
      />
      <section data-testid={SERVICES_PAGE.section} className="py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 space-y-10">
          {SERVICES_DETAIL.map((service, i) => {
            const Icon = ICONS[i];
            return (
              <div key={service.title} className="rounded-2xl border border-brand-border bg-brand-surface p-7 sm:p-9">
                <Icon className="w-8 h-8 text-brand-orange mb-4" />
                <h2 className="font-display font-bold uppercase text-brand-text text-2xl sm:text-3xl">{service.title}</h2>
                <p className="mt-3 text-brand-muted text-sm sm:text-base leading-relaxed">{service.summary}</p>
                <ul className="mt-5 space-y-2.5">
                  {service.points.map((point) => (
                    <li key={point} className="flex gap-3 text-brand-muted text-sm sm:text-base">
                      <span className="text-brand-amber mt-1.5 w-1.5 h-1.5 rounded-full bg-brand-amber shrink-0" />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}

          <div className="rounded-2xl border border-brand-border bg-brand-surface2 p-7 sm:p-9 text-center">
            <p className="font-display font-bold uppercase text-brand-text text-xl sm:text-2xl">Ready to build your container order?</p>
            <a
              href="/#order-form"
              className="mt-5 inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-7 py-3 transition-colors"
            >
              Request a Quote
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
